import { LitElement, css, html } from "lit"
import { when } from "lit/directives/when.js"

export class ProductImages extends LitElement {
	static properties = {
		images: { type: Array },
		rendered: { type: Boolean, state: true },
	}

	constructor() {
		super()
		this.images = []
		this._swiperInitialized = false
		this.rendered = false
	}
	connectedCallback() {
		console.log("connected product images")
		super.connectedCallback()
		this.rendered = true
	}
	createRenderRoot() {
		return this
	}

	firstUpdated(changedProperties) {
		console.log("update product images")
		const swiperEl = this.querySelector(".product-swiper")
		console.log(swiperEl)
		if (!swiperEl) return
		if (this._swiperInitialized) return
		console.log(swiperEl)
		const params = {
			slidesPerView: 1,

			injectStyles: [
				`
          :host{
             --swiper-navigation-size: 20px;
            --swiper-navigation-color: #FAFAFA;
          }
        img{
          height:100%;
          max-height:400px;
        }
          .swiper-button-next, .swiper-button-prev{
            background-color: #4B883C;
            border-radius: 50%;
            width: 38px;
            height: 38px;
          }
          .swiper-button-next svg, .swiper-button-prev svg{
            width: 8.42px;
            height: 14.576px;
          }
        `,
			],
		}

		Object.assign(swiperEl, params)

		swiperEl.initialize()

		this._swiperInitialized = true
	}
	render() {
		return html`<swiper-container
				slides-per-view=${1}
				navigation
				equal-height
				height="400"
				init="false"
				thumbs-swiper=".thumb-swiper"
				space-between="20"
				class="product-swiper">
				${this.images.map(
					image => html`
						<swiper-slide>
							<img style="width:100%"  src="${image}" />
						</swiper-slide>
					`
				)}
			</swiper-container>
      ${this.images.length > 1 ? html`
        
			<swiper-container
				init
				class="thumb-swiper"
				slides-per-view="4"
				height="100"
				equal-height
				space-between="10">
				${this.images.map(
					image => html`
						<swiper-slide>
							<img style="height: auto;max-height:150px;width:100%;" src="${image}" />
						</swiper-slide>
					`
				)}

			</swiper-container>`: html``} `
	}
}
